// Menu - Configure
import { configRoutes } from '../../../utility/route-locations';
import InspectionReasons from './inspection/InspectionReasons';
import DamageAreas from './inspection/DamageAreas';
import VideoOptions from './inspection/VideoOptions';
import ManageUsers from './company/ManageUsers';
import Checklists from './inspection/Checklists';
import ContactDetails from './company/ContactDetails';
import VehicleDetails from './vehicle/VehicleDetails';
import EmailContent from './company/EmailContent';
import Locations from "./location/Locations";


const configMenuStructure = {
  groups: [{
    name: 'group',
    titleId: 'company',
    items: [
      {
        name: 'contact',
        titleId: 'contactDetails',
        path: configRoutes.configure_contact_details,
        component: ContactDetails,
      },
      {
        name: 'locations',
        titleId: 'locations',
        path: configRoutes.configure_locations,
        component: Locations,
      },
      {
        name: 'users',
        titleId: 'identity',
        path: configRoutes.configure_users,
        component: ManageUsers,
      },
      {
        name: 'email-content',
        titleId: 'emailContent',
        path: configRoutes.configure_email_content,
        component: EmailContent,
      },
    ],
  }, {
    name: 'vehicles',
    titleId: 'vehicleGroup',
    items: [
      {
        name: 'maintain',
        titleId: 'vehicleManagement',
        path: configRoutes.configure_vehicle,
        component: VehicleDetails,
      },
    ],
  }, {
    name: 'inspection',
    titleId: 'inspection',
    items: [
      {
        name: 'reasons',
        titleId: 'reasons',
        path: configRoutes.configure_reasons,
        component: InspectionReasons,
      },
      {
        name: 'checklists',
        titleId: 'checklists',
        path: configRoutes.configure_checklists,
        component: Checklists,
      },
      {
        name: 'damages',
        titleId: 'damages',
        path: configRoutes.configure_damages,
        component: DamageAreas,
      },
      {
        name: 'video-options',
        titleId: 'videoOptions',
        path: configRoutes.configure_video_options,
        component: VideoOptions,
      },
    ],
  }],
};

export default configMenuStructure;
